export default __webpack_public_path__ + "static/media/177085.1d55402c.jpg";